module.exports = __webpack_public_path__ + "img/ProformaIcon.86698f6f.svg";